var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMagnifying(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0302 34.9855L31.5908 31.5476",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0909 40.7015L39.6599 35.2705C38.4868 34.0973 36.4447 34.0973 35.2716 35.2705C34.6851 35.857 34.3623 36.636 34.3623 37.4646C34.3623 38.2932 34.6851 39.0722 35.2716 39.6587L40.7026 45.0898C41.2892 45.6763 42.0682 45.9991 42.8968 45.9991C43.7254 45.9991 44.5044 45.6763 45.0909 45.0898C45.6775 44.5032 46.0002 43.7242 46.0002 42.8956C46.0002 42.067 45.6775 41.288 45.0909 40.7015Z",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8448 36.6897C28.7003 36.6897 36.6897 28.7003 36.6897 18.8448C36.6897 8.9894 28.7003 1 18.8448 1C8.9894 1 1 8.9894 1 18.8448C1 28.7003 8.9894 36.6897 18.8448 36.6897Z",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3955 22.7605H17.2913C17.2913 21.9069 17.9898 21.2084 18.8434 21.2084C19.6971 21.2084 20.3955 21.9084 20.3955 22.7605Z",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8278 18.8474C26.2469 18.8474 26.6038 19.2044 26.6038 19.6235C26.6038 20.0425 26.2469 20.3995 25.8278 20.3995C25.4087 20.3995 25.0518 20.0425 25.0518 19.6235C25.0518 19.2044 25.4087 18.8474 25.8278 18.8474Z",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8619 18.8474C12.2804 18.8474 12.6369 19.2039 12.6369 19.6224C12.6369 20.0409 12.2804 20.3974 11.8619 20.3974C11.4434 20.3974 11.0869 20.0409 11.0869 19.6224C11.0869 19.2039 11.4434 18.8474 11.8619 18.8474Z",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnifying);
export default __webpack_public_path__ + "static/media/icon-magnifying.c2fd5988d6a77f47cf3ba11f73f28c3b.svg";
export { ForwardRef as ReactComponent };